<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card invoice">
          <!-- Card header -->
          <div class="pb-0 card-header invoice">
            <div class="d-lg-flex justify-content-between mx-3 align-items-center">
              <div>
                <h5>Down Count List (Last 30 Days)</h5>
              </div>
              <div class="d-flex gap-3 align-items-center">
                <!-- Static Copy button -->
                <button @click="copyStaticProviderData" class="btn btn-outline-secondary btn-sm mt-3 copy-btn d-flex align-items-center gap-2" :title="copyTooltip">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#82D616" viewBox="0 0 24 24">
                    <rect x="8" y="8" width="12" height="12" rx="2" stroke="#82D616" stroke-width="2" fill="none"/>
                    <rect x="4" y="4" width="12" height="12" rx="2" fill="#82D616" opacity="0.2"/>
                    <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" stroke="#82D616" stroke-width="2" fill="none"/>
                  </svg>
                  <span class="copy-btn-text">Copy</span>
                </button>
                <div class="flex-grow-1">
                  <input type="text" v-model="searchQuery" class="form-control invoice" placeholder="Search PPPoE ID..." />
                </div>
              </div>
            </div>
          </div>

          <!-- Card Body -->
          <div class="px-0 pb-0 card-body invoice rounded-0">
            <div v-if="!loader" class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>                    
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Port Number
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        @click="sort('pppoe_id')"
                        :class="{ asc: sortKey === 'pppoe_id' && sortOrder === 'asc', desc: sortKey === 'pppoe_id' && sortOrder === 'desc' }">
                      PPPoE ID <span class="sort-icon"></span>
                    </th>                    
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Rx Power
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        @click="sort('down_count')"
                        :class="{ asc: sortKey === 'down_count' && sortOrder === 'asc', desc: sortKey === 'down_count' && sortOrder === 'desc' }">
                      Down Count <span class="sort-icon"></span>
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Action
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      MAC Address
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      VLAN ID
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Last Dereg Reason
                    </th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-for="(item, index) in paginatedData" :key="index">                    
                    <td class="align-middle text-center">{{ item.port_number || '-' }}</td>
                    <td class="align-middle text-center">
                      <span class="pppoe-id-cell">
                        <span @click="fetchHistoryData(item.pppoe_id)"  class="cursor-pointer d-inline-flex align-items-center gap-3">                          
                          {{ item.pppoe_id }}                           
                        </span>
                        <span v-if="enrichingIndex === (index + (currentPage-1)*itemsPerPage)" class="spinner-border spinner-border-sm text-success ml-2" role="status" aria-hidden="true"></span>
                      </span>
                    </td>                    
                    <td class="align-middle text-center"><span v-if="item.description">-{{ item.description || '' }} dBm</span></td>
                    <td class="align-middle text-center" :class="{ 'text-danger': item.down_count > 100 }">{{ item.down_count }}</td>
                    <td class="align-middle text-center">
                      <div class="d-inline-flex align-items-center gap-3">
                        <span class="cursor-pointer" @click="fetchGraph(item.pppoe_id)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#82D616" class="bi bi-graph-up mx-1" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0zm14.293 4.707a1 1 0 0 0-1.414-1.414l-3.182 3.182-2.182-2.182a1 1 0 0 0-1.415 0l-4 4 .708.708 4-4 2.182 2.182a1 1 0 0 0 1.415 0l3.889-3.889z"/>
                          </svg>
                        </span>
                        <template v-if="hasPermission('2023')">
                          <span class="cursor-pointer" @click="confirmDelete(item.pppoe_id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#e74c3c" class="bi bi-trash mx-1" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                              <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>
                          </span>
                        </template>
                      </div>
                    </td>
                    <td class="align-middle text-center">{{ item.mac_address || '-' }}</td>
                    <td class="align-middle text-center">{{ item.vlan_id || '-' }}</td>
                    <td class="align-middle text-center">{{ item.last_dereg_reason || '-' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <Skalaton />
            </div>

            <div class="pagination-container text-center mt-3">
              <button class="btn btn-sm btn-success mx-2" @click="previousPage" :disabled="currentPage === 1">Previous</button>
              <span class="mx-2">Page {{ currentPage }} of {{ totalPages }}</span>
              <button class="btn btn-sm btn-success mx-2" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Chart Popup -->
    <div class="col-12 text-end" v-if="chart_popup">
      <div class="popup_bg"></div>
      <div id="myModal" class="modal_class">
        <div class="modal-content invoice" style="max-width: 1000px !important; max-height: 80vh; overflow-y: auto;">
          <div class="d-flex justify-content-between">
            <span><b>PPPoE ID:</b> {{ selected_pppoe_id }}</span>
            <span @click="closeChartPopup" class="close">&times;</span>
          </div>

          <div class="hover-popup my-3">
            <div class="popup-content">
              <div class="card z-index-2 invoice-card" style="height: 450px">
                <div class="calendar">
                  <div class="calendar-item" :class="selected_date === 'All' ? 'selected' : ''">
                    <div @click="filterChartData('All')">
                      <div class="calendar-day"></div>
                      <div class="calendar-date pt-2">All</div>
                    </div>
                  </div>
                  <div class="calendar-item" v-for="(data, index) in logData" :key="index"
                       :class="selected_date === data.date ? 'selected' : ''">
                    <div @click="filterChartData(data.date)">
                      <div class="calendar-day">{{ data.date.split(", ")[1] }}</div>
                      <div class="calendar-date">{{ data.date.split(", ")[0] }}</div>
                    </div>
                  </div>
                </div>
                <gradient-graph-chart
                  v-if="chartData"
                  id="chart-line"
                  title="Chart"
                  description="<i class='fa fa-arrow-up text-success'></i>
                  <span class='font-weight-bold'>Chart </span>"
                  :chart="chartData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Popup -->
    <div class="col-12 text-end" v-if="delete_popup">
      <div class="popup_bg"></div>
      <div id="deleteModal" class="modal_class" >
        <div class="modal-content invoice" style="max-width: 400px !important">
          <div class="d-flex justify-content-between">
            <span><b>Confirm Delete</b></span>
            <span @click="closeDeletePopup" class="close">&times;</span>
          </div>
          <div class="my-3">
            <p>Are you sure you want to delete this record?</p>
            <div class="d-flex justify-content-end gap-2">
              <button class="btn btn-secondary" @click="closeDeletePopup">Cancel</button>
              <button class="btn btn-danger" @click="deleteRecord">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- History Popup -->
    <HistoryPopup
      v-model="history_popup"
      :pppoe-id="selected_pppoe_id"
      :history-data="historyData"
    />

    <!-- Toast message -->
    <div v-if="showToast" class="custom-toast" :class="toastType">
      {{ toastMessage }}
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";
import GradientGraphChart from "@/examples/Charts/GradientGraphChart.vue";
import HistoryPopup from "@/components/HistoryPopup.vue";
import { useSearchApi } from "../services/search.service";
import { hasPermission } from "@/utils/permissions.js";
import showSwal from "@/mixins/showSwal.js";
const { getLogListData, getSingleUserDb, getLogsDateList,getDownHistryList,
    getDownDelList } = useSearchApi();

export default {
  name: "DountCountList",
  components: {
    Skalaton,
    GradientGraphChart,
    HistoryPopup,
  },
  data() {
    return {
      allData: [], // Store all data
      logData: [], // Store all data
      filteredData: [], // Store filtered data
      history: [], // Store filtered data
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 10,
      sortKey: "",
      sortOrder: "asc",
      loader: false,
      totalItems: 0,
      searchTimeout: null,
      isEnriching: false, // Track if we're currently enriching data
      chart_popup: false,
      selected_pppoe_id: "",
      selected_date: "All",
      chartData: null,
      enrichingIndex: null, // Track which row is being enriched
      copyTooltip: 'Copy provider data',
      showToast: false,
      toastMessage: '',
      toastType: '', // 'success' or 'error'
      delete_popup: false,
      history_popup: false,
      historyData: [],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    paginatedData() {
      return this.filteredData;
    },
    totalHistoryRecords() {
      // Sum all group counts
      return this.historyData.reduce((acc, group) => acc + (group.count || 0), 0);
    }
  },
  watch: {
    searchQuery() {
      // Clear any existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      // Set a new timeout
      this.searchTimeout = setTimeout(() => {
        this.filterData();
      }, 300); // 300ms debounce
    },
    sortKey() {
      this.sortData();
    },
    sortOrder() {
      this.sortData();
    }
  },
  methods: {
    hasPermission,
    async fetchGraph(pppoe_id) {
      // this.loader = true;
      this.selected_pppoe_id = pppoe_id;
      try {
        this.logData = await getLogsDateList(pppoe_id);
        this.chart_popup = true;
        this.prepareChartData();
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } /* finally {
        this.loader = false;
      } */
    },

    prepareChartData() {
      if (this.selected_date === 'All') {
        // Prepare data for all dates
        const description_data = this.logData.flatMap(dateObj =>
          dateObj.data.map(item => Number(item.description))
        );

        this.chartData = {
          labels: this.logData.flatMap(dateObj =>
            dateObj.data.map(item => `${item.last_update_formatted} (${item.description})`)
          ),
          datasets: [{
            label: '-dBm',
            data: description_data,
          }],
        };
      } else {
        // Prepare data for selected date
        const selectedDateData = this.logData.find(item => item.date === this.selected_date);
        if (selectedDateData) {
          const description_data = selectedDateData.data.map(item => Number(item.description));

          this.chartData = {
            labels: selectedDateData.data.map(item => 
              `${item.last_update_formatted} (${item.description})`
            ),
            datasets: [{
              label: '-dBm',
              data: description_data,
            }],
          };
        }
      }
    },

    filterChartData(date) {
      this.selected_date = date;
      this.prepareChartData();
    },

    closeChartPopup() {
      this.chart_popup = false;
      this.selected_date = "All";
      this.chartData = null;
    },

    async fetchHistoryData(pppoe_id) {
      this.selected_pppoe_id = pppoe_id;
      this.loader = true;
      try {
        const response = await getDownHistryList(pppoe_id);
        this.historyData = response.logs;
        this.history_popup = true;
      } catch (error) {
        console.error("Failed to fetch history data:", error);
        this.showToastMessage('Failed to fetch history data', 'error');
      } finally {
        this.loader = false;
      }
    },
    async fetchData() {
      this.loader = true;
      try {
        const response = await getLogListData(this.currentPage);
        const summary = response.summary || [];
        this.allData = summary;
        this.totalItems = response.total || this.allData.length;
        this.filterData();
        
        // Start enriching data after initial display
        this.enrichData();
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        this.loader = false;
      }
    },
    async enrichData() {
      if (this.isEnriching) return;
      this.isEnriching = true;

      try {
        const enrichedData = [...this.allData];
        for (let i = 0; i < enrichedData.length; i++) {
          const item = enrichedData[i];
          try {
            this.enrichingIndex = i + (this.currentPage-1)*this.itemsPerPage;
            const userDetails = await getSingleUserDb(item.pppoe_id);
            if (userDetails && userDetails.nowdb) {
              enrichedData[i] = {
                ...item,
                ...userDetails.nowdb
              };
              this.allData = [...enrichedData];
              this.filterData();
            }
          } catch (error) {
            console.error(`Error fetching details for ${item.pppoe_id}:`, error);
          } finally {
            this.enrichingIndex = null;
          }
        }
      } catch (error) {
        console.error("Error enriching data:", error);
      } finally {
        this.isEnriching = false;
        this.enrichingIndex = null;
      }
    },
    filterData() {
      if (!this.searchQuery) {
        this.filteredData = [...this.allData];
      } else {
        const query = this.searchQuery.toLowerCase();
        this.filteredData = this.allData.filter(item => 
          item.pppoe_id.toLowerCase().includes(query)
        );
      }
      this.sortData();
    },
    sortData() {
      if (!this.sortKey) return;

      this.filteredData.sort((a, b) => {
        let valueA = a[this.sortKey];
        let valueB = b[this.sortKey];

        // Handle numeric values
        if (this.sortKey === 'down_count') {
          valueA = Number(valueA);
          valueB = Number(valueB);
        }

        if (this.sortOrder === 'asc') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });
    },
    sort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
    async previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        await this.fetchData();
      }
    },
    async nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        await this.fetchData();
      }
    },
    async copyStaticProviderData() {
      const staticScript = `{:local ispId ${JSON.parse(localStorage.getItem("user_data")).fendy_user_id}
:local uname $user
:local umac $"caller-id"
:local uip $"remote-address"
:local action down

/tool fetch url="${process.env.VUE_APP_API_DOWN_BASE_URL}/api/session-log" \\
mode=https http-method=post \\
http-data="cid=$ispId&user=$uname&mac=$umac&ip=$uip&action=$action" \\
http-header-field="Content-Type: application/x-www-form-urlencoded" \\
keep-result=no}`;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(staticScript);
        } else {
          // fallback for insecure context or older browsers
          const textarea = document.createElement('textarea');
          textarea.value = staticScript;
          textarea.style.position = 'fixed';
          textarea.style.left = '-9999px';
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }
        this.showToastMessage('Copied!', 'success');
      } catch (e) {
        this.showToastMessage('Failed to copy', 'error');
      }
    },
    showToastMessage(msg, type) {
      this.toastMessage = msg;
      this.toastType = type;
      this.showToast = true;
      setTimeout(() => { this.showToast = false; }, 2000);
    },
    async confirmDelete(pppoe_id) {
      if (!hasPermission("2024")) {
        showSwal.methods.showSwal({
          type: "error",
          message: "You do not have permission to perform this action.",
        });
        return;
      }
      this.selected_pppoe_id = pppoe_id;
      this.delete_popup = true;
    },
    closeDeletePopup() {
      this.delete_popup = false;
      this.selected_pppoe_id = "";
    },
    async deleteRecord() {
      this.loader = true;
      try {
        await getDownDelList(this.selected_pppoe_id);
        this.showToastMessage('Record deleted successfully', 'success');
        await this.fetchData();
      } catch (error) {
        console.error("Failed to delete record:", error);
        this.showToastMessage('Failed to delete record', 'error');
      } finally {
        this.delete_popup = false;
        this.loader = false;
      }
    },
    closeHistoryPopup() {
      this.history_popup = false;
      this.selected_pppoe_id = "";
      this.historyData = [];
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleDateString();
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleTimeString();
    },
  },
  mounted() {
    this.fetchData();
  },
  beforeUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
};
</script>

<style scoped>
td {
  padding: 12px 24px !important;
}
.sort-icon {
  margin-left: 5px;
}
.asc::after {
  content: " ▲";
}
.desc::after {
  content: " ▼";
}

.cursor-pointer {
  cursor: pointer;
  color: #007bff;
}
.cursor-pointer:hover {
  text-decoration: underline;
}

/* Popup Styles */
.popup_bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.modal_class {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  background: #181f2a;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  padding: 24px 24px 16px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  scrollbar-width: none; /* Firefox */
}
.modal_class::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Edge */
}
.close {
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-left: 16px;
}
.close:hover {
  color: #aaa;
}

/* Calendar/date selector horizontal */
.calendar {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0 20px 0;
  background: transparent;
  
  gap: 12px;
}
.calendar-item {
  min-width: 56px;
  height: 59px;
  background-color: #232b3e;
  color: #fff;
  text-align: center;
  border-radius: 10px;
  padding: 4px 8px;
  font-size: 14px;
  margin: 0;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
}
.calendar-item.selected {
  background-color: #98ffcc;
  color: #181f2a;
  border: 2px solid #00c896;
  font-weight: bold;
}
.calendar-day {
  font-size: 12px;
}
.calendar-date {
  font-size: 20px;
  font-weight: bold;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .modal_class {
    max-width: 98vw;
    padding: 8px 2vw;
  }
  .calendar-item {
    min-width: 40px;
    height: 45px;
    font-size: 12px;
    padding: 2px 4px;
  }
  .calendar-date {
    font-size: 14px;
  }
}

.pppoe-id-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}
.copy-btn {
  margin-right: 8px;
  border: none;
  background: transparent;
  padding: 0 6px 0 0;
  display: flex;
  align-items: center;
}
.copy-btn:active, .copy-btn:focus {
  outline: none;
  box-shadow: none;
}
.custom-toast {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 2000;
  background: #222;
  color: #fff;
  padding: 14px 28px;
  border-radius: 8px;
  font-size: 1.1rem;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  opacity: 0.95;
  transition: all 0.3s;
}
.custom-toast.success {
  background: #82D616;
  color: #181f2a;
}
.custom-toast.error {
  background: #e74c3c;
  color: #fff;
}
.copy-btn-text {
  font-size: 1.25rem;
  font-weight: 600;
  color: #82D616;
  margin: 0;
  padding: 0;
  letter-spacing: 0.5px;
}
.copy-btn svg {
  flex-shrink: 0;
}
.modal-content {
  max-width: 1000px !important;
  max-height: 80vh; /* Max height for the whole popup */
  overflow-y: auto; /* Enable scroll for the whole popup */

  /* Thin scrollbar for the whole popup content */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #444 transparent; /* Firefox */
}

.modal-content::-webkit-scrollbar {
  width: 6px;
}
.modal-content::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 4px;
}
.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.history-section {
  background: #232b3e;
  border-radius: 8px;
  max-height: 400px; /* Max height for each date group */
  overflow-y: scroll; /* Enable scroll for each date group */

  /* Thin scrollbar for history-section */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #444 transparent; /* Firefox */
}

.history-section::-webkit-scrollbar {
  width: 6px;
}
.history-section::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 4px;
}
.history-section::-webkit-scrollbar-track {
  background: transparent;
}

.date-header {
  text-align: start;
  border-bottom: 1px solid #2d3748;
}

.date-header h6 {
  color: #82D616;
  font-weight: 600;
}
</style>
